navArrowsDown = document.querySelector('.navbar').querySelectorAll('.fa-angle-down');
navArrowsRight = document.querySelector('.navbar').querySelectorAll('.fa-angle-right');


navArrowsDown.forEach(element => {
  element.addEventListener("click", function() {
    check = this.nextElementSibling.classList.contains("show")
    if (check) {
      navArrowsDown.forEach(nav=>nav.nextElementSibling.classList.remove('show'))
      navArrowsDown.forEach(nav=>nav.classList.remove('turn'))
    } else {
      navArrowsDown.forEach(nav=>nav.nextElementSibling.classList.remove('show'))
      navArrowsDown.forEach(nav=>nav.classList.remove('turn'))
      this.nextElementSibling.classList.add('show');
      this.classList.add('turn');
    }
  })
})

navArrowsRight.forEach(element => {
  element.addEventListener("click", function() {
    check = this.nextElementSibling.classList.contains("show")
    if (check) {
      navArrowsRight.forEach(nav=>nav.nextElementSibling.classList.remove('show'))
      navArrowsRight.forEach(nav=>nav.classList.remove('turn-right'))
    } else {
      navArrowsRight.forEach(nav=>nav.nextElementSibling.classList.remove('show'))
      navArrowsRight.forEach(nav=>nav.classList.remove('turn-right'))
      this.nextElementSibling.classList.add('show');
      this.classList.add('turn-right')
    }
  })
})





